import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { Draggable, Droppable } from 'primeng/dragdrop';
import { TreeTableModule } from 'primeng/treetable';
import { CdkContextMenuTrigger, CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { ProjectListComponent } from './project-list.component';
import { CoreModule } from '../../core/core.module';
import { RouterModule } from '@angular/router';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@bluehalo/ngx-leaflet-markercluster';
import { ProjectMapComponent } from '../project-map/project-map.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        TranslatePipe,
        TableModule,
        ScrollingModule,
        Draggable,
        Droppable,
        TreeTableModule,
        CdkContextMenuTrigger,
        CdkMenu,
        CdkMenuItem,
        CoreModule,
        RouterModule,
        NgOptimizedImage,
        LeafletModule,
        LeafletMarkerClusterModule,
    ],
    declarations: [ProjectListComponent, ProjectMapComponent],
    exports: [ProjectListComponent],
})
export class ProjectListModule {}
